import { useEffect } from 'react';
import PropTypes from 'prop-types';
const ACTIVATION_REDIRECT_URL = process.env.REACT_APP_ACTIVATION_REDIRECT_URL;

const ActivationSuccess = ({ strings }) => {
  useEffect(() => {
    setTimeout(() => {
      window.location.href = ACTIVATION_REDIRECT_URL;
    }, 5000);
  }, []);

  const createSubheadingMarkup = () => ({
    __html: strings.activationRedirect.formatUimTranslationLink(
      strings.clickHere,
      ACTIVATION_REDIRECT_URL
    ),
  });

  return (
    <div className="centered row">
      <div className="main">
        <i className="icon--success icon" />
        <h1 className="page-heading">{strings.activationSuccessful}</h1>
        <p
          className="site-subheading"
          dangerouslySetInnerHTML={createSubheadingMarkup()}
        />
      </div>
    </div>
  );
};

ActivationSuccess.propTypes = {
  strings: PropTypes.object.isRequired,
};

export default ActivationSuccess;
